export default "__VITE_ASSET__Dd7U3$34__"